import { render, staticRenderFns } from "./LayersListKonva.vue?vue&type=template&id=63be0f34&scoped=true"
import script from "./LayersListKonva.vue?vue&type=script&lang=js"
export * from "./LayersListKonva.vue?vue&type=script&lang=js"
import style0 from "./LayersListKonva.vue?vue&type=style&index=0&id=63be0f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be0f34",
  null
  
)

export default component.exports